import { render, staticRenderFns } from "./SchoolProfile.vue?vue&type=template&id=df3b762e&"
import script from "./SchoolProfile.vue?vue&type=script&lang=js&"
export * from "./SchoolProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports